import { Field } from 'redux-form'
import { CardElement } from '@stripe/react-stripe-js'
import { useSelector } from 'react-redux'
import { getUpdateCardFlag } from 'ducks/trialWarning'
import SettingsFormField from 'components/Shared/Forms/SettingsFormField'
import WrappedNativeSelect from 'components/Shared/Forms/WrappedNativeSelect'
import { COUNTRY_CODES } from '../../../../constants'

const SavedCards = ({ cardBrand, cardNumber, updateCardFlagTrue }) => (
  <div className="payment-form payment-summary billing-payment-form">
    <div className="settings-form-row">
      <h2> Payment Details </h2>
      <div className="settings-form-input settings-stripe-input">
        Credit Card: {cardBrand} ending in •••• {cardNumber}
      </div>
      <div className="update-card-btn-wrapper">
        <a className="update-card-btn" onClick={updateCardFlagTrue}>
          Update card
        </a>
      </div>
    </div>
  </div>
)

const OldPaymentForm = ({
  subscription,
  updatePaymentSettings,
  updateCardFlagTrue,
}) => {
  const updateCardFlag = useSelector(getUpdateCardFlag)

  const { cardNumber = false, cardBrand } = subscription
  const hasCard = subscription?.configured && cardNumber && cardBrand

  const shouldShowSavedCards =
    hasCard && !updateCardFlag && subscription.planType !== 'free'

  if (shouldShowSavedCards) {
    return (
      <SavedCards
        cardBrand={cardBrand.toUpperCase()}
        cardNumber={cardNumber}
        updateCardFlagTrue={updateCardFlagTrue}
      />
    )
  }

  const margin = updatePaymentSettings ? 'auto' : undefined
  const COUNTRY_OPTIONS = COUNTRY_CODES.map(c => ({
    label: c.name,
    value: c.code,
  }))

  return (
    <div className="billing-payment-form payment-form" style={{ margin }}>
      <div className="settings-form-row">
        <h2> Payment Details </h2>
        <label>Credit or Debit Card</label>
        <div className="settings-form-input settings-stripe-input">
          <CardElement options={{ hidePostalCode: true }} />
        </div>
      </div>
      <Field
        small
        label="Name on Card"
        name="name"
        component={SettingsFormField}
      />
      <h2> Billing Details </h2>
      <div className="payment-form-country-input">
        <Field
          small
          displayName="Country of billing address"
          name="address_country"
          options={COUNTRY_OPTIONS}
          component={WrappedNativeSelect}
          label="Country of billing address"
        />
      </div>

      <Field
        small
        label="Street Address"
        name="address_line1"
        component={SettingsFormField}
      />
      <Field
        small
        label="City"
        name="address_city"
        component={SettingsFormField}
      />
      <Field
        small
        label="Postal Code"
        name="address_zip"
        component={SettingsFormField}
      />
    </div>
  )
}

export default OldPaymentForm
